const serviceType_attributeDefinitions = {
    Id: true,
    AttributeDefinitionEntities: {
        IdAttributeDefinition: true,
        AttributeDefinition: {
            Name: true,
            FieldType: {
                IsBoolean: true,
                IsDate: true,
                IsNumeric: true,
                IsString: true,
            },
            MustBeUnique: true,
            AttributeDefinitionSizeType: {
                Key: true,
                Size: true,
            },
            IdAttributeDefinitionCategory: true,
            AttributeDefinitionCategory: {
                Id: true,
                Name: true,
                Key: true,
                Enabled: true,
                LocalizedCaption: true,
                Caption: true,
            },
        },
        Required: true,
        Enabled: true,
    },
};

export default serviceType_attributeDefinitions;
